class MenuShopDropdown extends HTMLElement {
  constructor() {
    super();
    this.accordionItems = this.querySelectorAll('.collection-accordion-item');
    this.collectionContainer = this.querySelector('.menu-shop-dropdown__collection');
    this.isAnimating = false;
    this.hoverTimeout = null;
    this.init();
  }

  init() {
    this.querySelectorAll('.product-link').forEach(link => {
      link.addEventListener('mouseenter', this.handleAccordionHover.bind(this));
      link.addEventListener('click', (e) => e.preventDefault());
    });

    // Add mouseleave to cancel pending hovers
    this.querySelectorAll('.collection-accordion-item').forEach(item => {
      item.addEventListener('mouseleave', () => {
        if (this.hoverTimeout) {
          clearTimeout(this.hoverTimeout);
          this.hoverTimeout = null;
        }
      });
    });
  }

  handleAccordionHover(event) {
    const parentItem = event.currentTarget.closest('.collection-accordion-item');
    if (!parentItem || this.isAnimating) return;
    
    // Already expanded? Do nothing
    if (parentItem.getAttribute('data-expanded') === 'true') return;

    // Clear any pending hover
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
    }

    // Small delay to prevent accidental triggers (debounce)
    this.hoverTimeout = setTimeout(() => {
      this.expandItem(parentItem);
    }, 150);
  }

  expandItem(targetItem) {
    this.isAnimating = true;

    // Lock the container height to prevent layout jumps
    if (this.collectionContainer) {
      const currentHeight = this.collectionContainer.offsetHeight;
      this.collectionContainer.style.minHeight = `${currentHeight}px`;
    }

    // Collapse all items and expand target simultaneously
    this.accordionItems.forEach(item => {
      if (item === targetItem) {
        item.setAttribute('data-expanded', 'true');
        item.classList.add('is-expanding');
      } else if (item.getAttribute('data-expanded') === 'true') {
        item.setAttribute('data-expanded', 'false');
        item.classList.add('is-collapsing');
      }
    });

    // Clean up after animation completes
    setTimeout(() => {
      this.accordionItems.forEach(item => {
        item.classList.remove('is-collapsing', 'is-expanding');
      });
      
      // Release the height lock smoothly
      if (this.collectionContainer) {
        const newHeight = this.collectionContainer.scrollHeight;
        this.collectionContainer.style.minHeight = `${newHeight}px`;
        
        // Then remove the fixed height after transition
        setTimeout(() => {
          this.collectionContainer.style.minHeight = '';
          this.isAnimating = false;
        }, 150);
      } else {
        this.isAnimating = false;
      }
    }, 500);
  }
}

customElements.define('menu-shop-dropdown', MenuShopDropdown);
